import React from "react";
import PropTypes from 'prop-types';

export default class Footer extends React.PureComponent
{
    static propTypes = {
        language: PropTypes.string.isRequired,
        customerData: PropTypes.objectOf(Promise).isRequired,
        consultant: PropTypes.object.isRequired,
        customerName: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {loading: true};
        this.loadedCustomerData();
    }

    loadedCustomerData = () => {
        this.props.customerData.then((customerData) => {
            this.setState({loading: false, content: customerData.result.gateSettings ? customerData.result.gateSettings.positionExportFooter : null})
        });
    };

    stripHtml = (html) =>
    {
        const tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    };

    renderWrapper = (children) => {
        return (
            <div className="col-xl-6 col-lg-6 col-12">
                <div className="company-information details-section"
                     style={{overflow: "hidden"}}>
                    {children}
                </div>
            </div>
        );
    };

    render() {
        if (this.state['loading']) {
            return null;
        }
        if (!this.state['content'] || this.stripHtml(this.state['content']).length === 0) {
            if (!this.props.consultant) {
                return null;
            }
            return this.renderWrapper(
                <div>
                    <h4>{window.Translator.getSlug('Contact', this.props.language)}</h4>
                    {(this.props.consultant.firstname || this.props.consultant.lastname) && <div><span><strong>{window.Translator.getSlug('Consultant', this.props.language)}: </strong></span>{this.props.consultant.firstname} {this.props.consultant.lastname}</div>}
                    {this.props.consultant.email && <div><span><strong>{window.Translator.getSlug('Email', this.props.language)}: </strong></span>{this.props.consultant.email}</div>}
                    {this.props.consultant.phone && <div><span><strong>{window.Translator.getSlug('Phone', this.props.language)}: </strong></span>{this.props.consultant.phone}</div>}
                </div>
            );
        }
        let content = this.state['content'];
		if (this.props.consultant) {
			content = content.split('#Email#').join(this.props.consultant.email || '');
			content = content.split('#FirstName#').join(this.props.consultant.firstname || '');
			content = content.split('#LastName#').join(this.props.consultant.lastname || '');
			content = content.split('#Phone#').join(this.props.consultant.phone || '');
			content = content.split('#Picture#').join(this.props.consultant.picture ? ('<img src="' + this.props.consultant.picture + '" alt="' + this.props.consultant.firstname + ' '+ this.props.consultant.lastname + '" style= "max-height:180px;max-width: 180px"/>') : '');
			content = content.split('#Position#').join(this.props.consultant.position || '');
			content = content.split('#DisplayName#').join(this.props.consultant.displayName || '');
			return this.renderWrapper(<div dangerouslySetInnerHTML={{__html:content}}/>);
		}
        return null;
    }
}
